import request, { ResponseData, PagerData } from '@/libs/request/request'
import { Donation } from 'src/api/donation/Donation'
import { MeritsListQuery } from 'src/api/merits/MeritsListQuery'
import { GenealogyMember } from 'src/api/genealogy/GenealogyMember'

// MeritsList
export type MeritsList = {

  createBy?:number

  createByName?:string

  // 创建时间
  createTime?:string

  donation?:Donation

  // 捐赠项目id
  donationId?:number

  // 捐赠时间
  donationTime?:string

  // 业务Id
  id?:number

  // 金额
  money?:number

  updateBy?:number

  updateByName?:string

  // 更新时间
  updateTime?:string

  // 用户id
  userId?:number

  // 标题
  version?:number

  // 村庄id
  villageId?:number

  // 族谱成员
  genealogyMember?:GenealogyMember

  // 族谱成员id
  memberId?:number

  // 族谱id
  genealogyId?:number

  // 头像
  avatar?:string
}

export default class MeritsListService {
  /**
   * 添加一个功德榜/捐赠记录
   * @param {MeritsList} item 功德榜实体
   **/
  static addOneMeritsList (item?:MeritsList):Promise<ResponseData<MeritsList>> {
    return request<ResponseData<MeritsList>>({
      method: 'POST',
      data: item,
      url: '/admin/MeritsList/MeritsList'
    })
  }

  /**
   * 更新一个功德榜/捐赠记录
   * @param {MeritsList} item 功德榜实体
   **/
  static updateOneMeritsList (item?:MeritsList):Promise<ResponseData<MeritsList>> {
    return request<ResponseData<MeritsList>>({
      method: 'PUT',
      data: item,
      url: '/admin/MeritsList/MeritsList'
    })
  }

  /**
   * 获取功德榜/捐赠记录的分页数据
   * @param {MeritsListQuery} query 功德榜实体查询条件
   **/
  static getPagesOfMeritsList (query?:MeritsListQuery):Promise<ResponseData<PagerData<MeritsList>>> {
    return request<ResponseData<PagerData<MeritsList>>>({
      method: 'POST',
      data: query,
      url: '/admin/MeritsList/MeritsList/pages'
    })
  }

  /**
   * 通过id获取一个功德榜/捐赠记录
   * @param {number} id 功德榜id
   **/
  static getOneMeritsList (id:number):Promise<ResponseData<MeritsList>> {
    return request<ResponseData<MeritsList>>({
      method: 'GET',
      url: `/admin/MeritsList/MeritsList/${id}`
    })
  }

  /**
   * 删除一个功德榜/捐赠记录
   * @param {number} id 功德榜id
   **/
  static deleteOneMeritsList (id:number):Promise<ResponseData<boolean>> {
    return request<ResponseData<boolean>>({
      method: 'DELETE',
      url: `/admin/MeritsList/MeritsList/${id}`
    })
  }

  /**
   * 批量录入功德榜数据/捐赠记录
   * @param {Array<MeritsList>} item 功德榜实体
   **/
  static addMeritsList (item?:Array<MeritsList>):Promise<ResponseData<Array<MeritsList>>> {
    return request<ResponseData<Array<MeritsList>>>({
      method: 'POST',
      data: item,
      url: '/admin/MeritsList/MeritsList/list'
    })
  }
}
